const Divider = () => {
  return (
    <div className="">
      <br />
      <br />
      <br />
    </div>
  );
};

export default Divider;
